import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import ProductCard from './Products/ProductCard'

const GridContainer = ({ list, component, loading }) => {
    return (
        <React.Fragment>
            <Grid container spacing={2} alignItems="stretch" alignContent="stretch" >
                {
                    list.map((item, index) => {
                        return (
                            <Grid item xs={12} md={6} lg={3} xl={2}  key={index}
                                /* style={{
                                    animation:`scale-in-center 0.6s ease-in-out ${index/33}s both`
                                }} */ >
                                {
                                    React.cloneElement(component, { ...item }, null)
                                }
                            </Grid>
                        )
                    })
                }
            </Grid>
            {loading &&
                <Grid container spacing={2} alignItems="stretch" alignContent="stretch">
                    <Grid item xs={12} md={6} lg={3} xl={4} >
                        <ProductCard loading />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} xl={4} >
                        <ProductCard loading />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} xl={4} >
                        <ProductCard loading />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} xl={4} >
                        <ProductCard loading />
                    </Grid>
                </Grid>}

        </React.Fragment >
    )
}

GridContainer.propTypes = {
    /**
     * Array
     */
    list: PropTypes.array.isRequired,
    /**
     * component element must be <NodeObject/>, use react clone to pass their props
     */
    component: PropTypes.node
}

export default GridContainer
